import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import ProtectedAdminRoute from "@/components/ProtectedRoutes/ProtectedAdminRoute";

const UploadACS = lazy(() => import("@/pages/admin/payroll/upload-acs/UploadACS"));
const Payouts = lazy(() => import("@/pages/admin/payroll/payouts/Payouts"));
const AddPayout = lazy(() => import("@/pages/admin/payroll/payouts/AddPayout/AddPayout"));
const EditPayout = lazy(() => import("@/pages/admin/payroll/payouts/EditPayout/EditPayout"));

const payrollRoutes: RouteObject[] = [
  {
    path: "upload-acs",
    element: <UploadACS />,
  },
  {
    path: "payouts",
    children: [
      {
        index: true,
        element: <Payouts />,
      },
      {
        path: "new",
        element: <AddPayout />,
      },
      {
        path: ":id",
        element: <EditPayout />,
      },
    ],
  },
];

export default payrollRoutes;
